import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import ne from './locales/ne.json';
import es from './locales/es.json';
import de from './locales/de.json';

// Custom language detector that reads from localStorage
const localStorageDetector = {
  type: 'languageDetector' as const,
  async: false,
  detect: (): string => {
    return localStorage.getItem('user_language') || 'en';
  },
  init: () => {},
  cacheUserLanguage: () => {},
};

i18n
  .use(localStorageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      it: { translation: it },
      ne: { translation: ne },
      es: { translation: es },
      de: { translation: de },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false,
    },
  });

// Listen for localStorage changes (when user changes language in another tab or shell)
window.addEventListener('storage', (event) => {
  if (event.key === 'user_language' && event.newValue) {
    i18n.changeLanguage(event.newValue);
  }
});

// Listen for custom event from app shell
window.addEventListener('languageChange', ((event: CustomEvent) => {
  if (event.detail?.language) {
    i18n.changeLanguage(event.detail.language);
  }
}) as EventListener);

export default i18n;
